export const GENRES = [
  'Rock', 'Pop', 'Jazz', 'Blues', 'Classical', 'Electronic',
  'Hip Hop', 'R&B', 'Country', 'Folk', 'Metal', 'Punk',
] as const;

export const SKILLS = [
  'Vocals', 'Guitar', 'Bass', 'Drums', 'Piano', 'Keyboard',
  'Violin', 'Cello', 'Double Bass', 'Saxophone', 'Trumpet',
  'Trombone', 'Flute', 'Clarinet', 'Harmonica', 'Accordion',
  'Harp', 'Banjo', 'Ukulele', 'Mandolin', 'Percussion',
  'Synthesizer', 'DJ', 'Beatbox', 'Production',
] as const;

export const BAND_STATUSES = [
  'Aktiv', 'Inaktiv', 'Suche Musiker', 'Suche Studio', 'Suche Auftritte'
] as const;

export const MUSICIAN_STATUSES = [
  'Aktiv', 'Inaktiv', 'Sucht Band'
] as const;

export type Genre = typeof GENRES[number];

// Translation keys for music constants
export const GENRE_TRANSLATION_KEYS = {
  'Rock': 'music.genres.rock',
  'Pop': 'music.genres.pop',
  'Jazz': 'music.genres.jazz',
  'Blues': 'music.genres.blues',
  'Classical': 'music.genres.classical',
  'Electronic': 'music.genres.electronic',
  'Hip Hop': 'music.genres.hipHop',
  'R&B': 'music.genres.rnb',
  'Country': 'music.genres.country',
  'Folk': 'music.genres.folk',
  'Metal': 'music.genres.metal',
  'Punk': 'music.genres.punk',
} as const;

export const SKILL_TRANSLATION_KEYS = {
  'Vocals': 'music.skills.vocals',
  'Guitar': 'music.skills.guitar',
  'Bass': 'music.skills.bass',
  'Drums': 'music.skills.drums',
  'Piano': 'music.skills.piano',
  'Keyboard': 'music.skills.keyboard',
  'Violin': 'music.skills.violin',
  'Cello': 'music.skills.cello',
  'Double Bass': 'music.skills.doubleBass',
  'Saxophone': 'music.skills.saxophone',
  'Trumpet': 'music.skills.trumpet',
  'Trombone': 'music.skills.trombone',
  'Flute': 'music.skills.flute',
  'Clarinet': 'music.skills.clarinet',
  'Harmonica': 'music.skills.harmonica',
  'Accordion': 'music.skills.accordion',
  'Harp': 'music.skills.harp',
  'Banjo': 'music.skills.banjo',
  'Ukulele': 'music.skills.ukulele',
  'Mandolin': 'music.skills.mandolin',
  'Percussion': 'music.skills.percussion',
  'Synthesizer': 'music.skills.synthesizer',
  'DJ': 'music.skills.dj',
  'Beatbox': 'music.skills.beatbox',
  'Production': 'music.skills.production',
} as const;

export const BAND_STATUS_TRANSLATION_KEYS = {
  'Aktiv': 'music.bandStatuses.active',
  'Inaktiv': 'music.bandStatuses.inactive',
  'Suche Musiker': 'music.bandStatuses.seekingMusicians',
  'Suche Studio': 'music.bandStatuses.seekingStudio',
  'Suche Auftritte': 'music.bandStatuses.seekingGigs',
} as const;

export const MUSICIAN_STATUS_TRANSLATION_KEYS = {
  'Aktiv': 'music.musicianStatuses.active',
  'Inaktiv': 'music.musicianStatuses.inactive',
  'Sucht Band': 'music.musicianStatuses.seekingBand',
} as const;